import LoginPageContainer from "./loginPage.container";

export default LoginPageContainer;
